module.exports = __webpack_public_path__ + "static/img/status-cancel.817b9fc9.svg";